import React, { useContext } from "react";
import { Box, Switch, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { ModuleContext } from "../utils/Constants";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";

export default function SaitSwitch(props) {
	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === props.objmod);

	const handleChange = (event) => {
		props.onChange(event.target.checked);
	};

	return isComponentVisible(objMod, props.hidden) ? (
		<Box
			sx={{
				...props.sx,
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Typography>{props.startLabel}</Typography>
			<Switch checked={props.value} onChange={handleChange} disabled={isComponentDisabled(objMod, props.disabled)} />
			<Typography>{props.endLabel}</Typography>
		</Box>
	) : null;
}
